export default __webpack_public_path__ + "static/media/chats.32984372.png";